// // import React, { useEffect, useState } from "react";
// // import "./GuidedTour.css";
// // import { useNavigate } from "react-router-dom";

// // const GuidedTour = ({
// //     steps = [],
// //     stepIndex,
// //     setStepIndex,
// //     onFinish,
// //     onAction,
// //     allowNavigation = false,
// // }) => {
// //     const [targetElement, setTargetElement] = useState(null);
// //     const navigate = useNavigate();

// //     const step =
// //         Array.isArray(steps) && stepIndex != null
// //             ? steps[stepIndex]
// //             : null;

// //     const isLast = stepIndex === steps.length - 1;
// //     const allowInteraction = !!step?.allowInteraction;

// //     /* -----------------------------------------------------
// //        1️⃣ Find target element
// //     ------------------------------------------------------ */
// //     useEffect(() => {
// //         if (!step?.selector) return;

// //         let attempts = 0;
// //         let cancelled = false;

// //         const findElement = () => {
// //             if (cancelled) return;

// //             const el = document.querySelector(step.selector);
// //             if (el) {
// //                 setTargetElement(el);
// //             } else if (attempts < 20) {
// //                 attempts++;
// //                 setTimeout(findElement, 200);
// //             }
// //         };

// //         setTargetElement(null);
// //         findElement();

// //         return () => {
// //             cancelled = true;
// //         };
// //     }, [step]);

// //     /* -----------------------------------------------------
// //        2️⃣ Enable click-through + auto-next for interaction
// //     ------------------------------------------------------ */
// //     useEffect(() => {
// //         if (!targetElement || !step?.allowInteraction) return;

// //         const handleClick = () => {
// //             setTimeout(() => {
// //                 setStepIndex((prev) => prev + 1);
// //             }, 300);
// //         };

// //         targetElement.addEventListener("click", handleClick);

// //         return () => {
// //             targetElement.removeEventListener("click", handleClick);
// //         };
// //     }, [targetElement, step]);


// //     /* -----------------------------------------------------
// //        3️⃣ Scroll element into view
// //     ------------------------------------------------------ */
// //     useEffect(() => {
// //         if (targetElement) {
// //             targetElement.scrollIntoView({
// //                 behavior: "smooth",
// //                 block: "center",
// //             });
// //         }
// //     }, [targetElement]);

// //     /* -----------------------------------------------------
// //        4️⃣ Disable page scrolling during tour
// //     ------------------------------------------------------ */
// //     useEffect(() => {
// //         document.body.style.overflow = "hidden";
// //         return () => {
// //             document.body.style.overflow = "";
// //         };
// //     }, []);

// //     /* -----------------------------------------------------
// //        🚫 Safe exit
// //     ------------------------------------------------------ */
// //     if (!step || !targetElement) return null;

// //     /* -----------------------------------------------------
// //        📐 Position calculations
// //     ------------------------------------------------------ */
// //     const rect = targetElement.getBoundingClientRect();

// //     const TOOLTIP_HEIGHT = 320;
// //     const GAP = 16;

// //     const spaceBelow = window.innerHeight - rect.bottom;
// //     const placeAbove = spaceBelow < TOOLTIP_HEIGHT + GAP;

// //     const tooltipTop = placeAbove
// //         ? rect.top - TOOLTIP_HEIGHT - GAP
// //         : rect.bottom + GAP;

// //     const tooltipLeft = Math.max(
// //         20,
// //         Math.min(rect.left + rect.width / 2 - 150, window.innerWidth - 320)
// //     );

// //     /* -----------------------------------------------------
// //        🧭 Handlers
// //     ------------------------------------------------------ */
// //     const handleSkip = () => onFinish?.();

// //     const handlePrev = () => {
// //         if (stepIndex === 0) return;

// //         const prevIndex = stepIndex - 1;
// //         const prevStep = steps[prevIndex];

// //         if (allowNavigation && prevStep?.route) {
// //             navigate(prevStep.route, {
// //                 state: { resumeTour: true, stepIndex: prevIndex },
// //             });
// //         } else {
// //             setStepIndex(prevIndex);
// //         }
// //     };

// //     const handleNext = () => {
// //         if (isLast) {
// //             onFinish?.();
// //             return;
// //         }

// //         const nextIndex = stepIndex + 1;
// //         const nextStep = steps[nextIndex];

// //         if (nextStep?.route && allowNavigation) {
// //             navigate(nextStep.route, {
// //                 state: { resumeTour: true, stepIndex: nextIndex },
// //             });
// //         } else {
// //             setStepIndex(nextIndex);
// //         }
// //     };

// //     /* -----------------------------------------------------
// //        🎨 Render
// //     ------------------------------------------------------ */
// //     return (
// //         <>
// //             {/* 🔦 BACKDROP / SPOTLIGHT */}
// //             {allowInteraction ? (
// //                 <div
// //                     className="gt-spotlight"
// //                     style={{
// //                         position: "fixed",
// //                         top: rect.top - 30,
// //                         left: rect.left - 30,
// //                         width: rect.width + 60,
// //                         height: rect.height + 60,
// //                         borderRadius: "18px",
// //                         boxShadow: "0 0 0 9999px rgba(0,0,0,0.75)",
// //                         pointerEvents: "none",
// //                         zIndex: 9997,
// //                     }}
// //                 />
// //             ) : (
// //                 <div
// //                     className="gt-overlay"
// //                     onClick={handleSkip}
// //                     style={{ zIndex: 9997 }}
// //                 />
// //             )}

// //             {/* 🔲 Highlight */}
// //             <div
// //                 className="gt-highlight"
// //                 style={{
// //                     top: rect.top - 8,
// //                     left: rect.left - 8,
// //                     width: rect.width + 16,
// //                     height: rect.height + 16,
// //                     zIndex: 9998,
// //                 }}
// //             />

// //             {/* 💬 Tooltip */}
// //             <div
// //                 className={`gt-tooltip ${placeAbove ? "gt-tooltip-above" : "gt-tooltip-below"}`}
// //                 style={{
// //                     top: tooltipTop,
// //                     left: tooltipLeft,
// //                     maxWidth: 300,
// //                     zIndex: 9999,
// //                 }}
// //             >
// //                 <div className="gt-header">
// //                     <div className="gt-avatar">👤</div>
// //                     <div>
// //                         <div className="gt-guide-name">Guide from Audree</div>
// //                         <div className="gt-guide-subtitle">Quick tour</div>
// //                     </div>
// //                     <button className="gt-close" onClick={handleSkip}>×</button>
// //                 </div>

// //                 <div className="gt-content">
// //                     {step.title && <h3 className="gt-title">{step.title}</h3>}
// //                     {step.text && <p className="gt-text">{step.text}</p>}
// //                 </div>

// //                 <div className="gt-footer">
// //                     <span className="gt-progress">
// //                         {stepIndex + 1} of {steps.length}
// //                     </span>

// //                     <div className="gt-buttons">
// //                         <button
// //                             className="gt-prev-btn"
// //                             onClick={handlePrev}
// //                             disabled={stepIndex === 0}
// //                         >
// //                             ← Previous
// //                         </button>

// //                         {!allowInteraction && (
// //                             <button className="gt-next-btn" onClick={handleNext}>
// //                                 {isLast ? "Finish" : "Next →"}
// //                             </button>
// //                         )}
// //                     </div>
// //                 </div>
// //             </div>
// //         </>
// //     );
// // };

// // export default GuidedTour;


// import React, { useEffect, useState } from "react";
// import "./GuidedTour.css";
// import { useNavigate } from "react-router-dom";

// const GuidedTour = ({
//   steps = [],
//   stepIndex,
//   setStepIndex,
//   onFinish,
//   onAction,
//   allowNavigation = false,
// }) => {
//   const [targetElement, setTargetElement] = useState(null);
//   const navigate = useNavigate();

//   const step =
//     Array.isArray(steps) && stepIndex != null ? steps[stepIndex] : null;

//   const isLast = stepIndex === steps.length - 1;
//   const allowInteraction = !!step?.allowInteraction;

//   // 1. Find target element with retry
//   useEffect(() => {
//     if (!step?.selector) return;

//     let attempts = 0;
//     let cancelled = false;

//     const findElement = () => {
//       if (cancelled) return;

//       const el = document.querySelector(step.selector);
//       if (el) {
//         setTargetElement(el);
//       } else if (attempts < 120) { // increased attempts slightly
//         attempts++;
//         setTimeout(findElement, 250);
//       }
//     };

//     setTargetElement(null);
//     findElement();

//     return () => {
//       cancelled = true;
//     };
//   }, [step]);

//   // 2. Handle interaction → click or change (for checkboxes)
//   useEffect(() => {
//     if (!targetElement || !step?.allowInteraction) return;

//     const advanceTour = () => {
//       setTimeout(() => {
//         setStepIndex((prev) => prev + 1);
//       }, 400);
//     };

//     // For checkboxes / inputs → listen to 'change'
//     if (targetElement.tagName === "INPUT" && targetElement.type === "checkbox") {
//       const handleChange = (e) => {
//         if (e.target.checked) {
//           advanceTour();
//         }
//       };
//       targetElement.addEventListener("change", handleChange);
//       return () => targetElement.removeEventListener("change", handleChange);
//     }

//     // For buttons, divs, etc. → listen to 'click'
//     targetElement.addEventListener("click", advanceTour);
//     return () => targetElement.removeEventListener("click", advanceTour);
//   }, [targetElement, step, setStepIndex]);

//   // 3. Scroll target into view
//   useEffect(() => {
//     if (targetElement) {
//       targetElement.scrollIntoView({
//         behavior: "smooth",
//         block: "center",
//       });
//     }
//   }, [targetElement]);

//   // 4. Disable body scroll during tour
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, []);

//   if (!step || !targetElement) return null;

//   // ────────────────────────────────────────────────
//   // Positioning logic
//   // ────────────────────────────────────────────────
//   const rect = targetElement.getBoundingClientRect();

//   const TOOLTIP_HEIGHT = 340; // slightly increased to be safe
//   const GAP = 24;             // increased gap

//   // Force placement ABOVE in most cases (better for instructions page)
//   const placeAbove = true; // or keep dynamic: spaceBelow < TOOLTIP_HEIGHT + GAP
//   // const spaceBelow = window.innerHeight - rect.bottom;
//   // const placeAbove = spaceBelow < TOOLTIP_HEIGHT + GAP;

//   const tooltipTop = placeAbove
//     ? rect.top - TOOLTIP_HEIGHT - GAP - 40   // extra offset upward
//     : rect.bottom + GAP;

//   const tooltipLeft = Math.max(
//     40,
//     Math.min(
//       rect.left + rect.width / 2 - 150 + 320, // shift right to avoid overlap
//       window.innerWidth - 340
//     )
//   );

//   // ────────────────────────────────────────────────
//   // Handlers
//   // ────────────────────────────────────────────────
//   const handleSkip = () => onFinish?.();

//   const handlePrev = () => {
//     if (stepIndex === 0) return;

//     const prevIndex = stepIndex - 1;
//     const prevStep = steps[prevIndex];

//     if (allowNavigation && prevStep?.route) {
//       navigate(prevStep.route, {
//         state: { resumeTour: true, stepIndex: prevIndex },
//       });
//     } else {
//       setStepIndex(prevIndex);
//     }
//   };

//   const handleNext = () => {
//     if (isLast) {
//       onFinish?.();
//       return;
//     }

//     const nextIndex = stepIndex + 1;
//     const nextStep = steps[nextIndex];

//     if (nextStep?.route && allowNavigation) {
//       navigate(nextStep.route, {
//         state: { resumeTour: true, stepIndex: nextIndex },
//       });
//     } else {
//       setStepIndex(nextIndex);
//     }
//   };

//   // ────────────────────────────────────────────────
//   // Render
//   // ────────────────────────────────────────────────
//   return (
//     <>
//       {/* BACKDROP / SPOTLIGHT */}
//       {allowInteraction ? (
//         <div
//           className="gt-spotlight"
//           style={{
//             position: "fixed",
//             top: rect.top - 60,           // larger padding
//             left: rect.left - 60,
//             width: rect.width + 120,      // wider spotlight
//             height: rect.height + 120,    // taller spotlight
//             borderRadius: "20px",
//             boxShadow: "0 0 0 9999px rgba(0,0,0,0.78)",
//             pointerEvents: "none",
//             zIndex: 9997,
//           }}
//         />
//       ) : (
//         <div
//           className="gt-overlay"
//           onClick={handleSkip}
//           style={{ zIndex: 9997 }}
//         />
//       )}

//       {/* HIGHLIGHT BORDER */}
//       <div
//         className="gt-highlight"
//         style={{
//           top: rect.top - 10,
//           left: rect.left - 10,
//           width: rect.width + 20,
//           height: rect.height + 20,
//           zIndex: 9998,
//         }}
//       />

//       {/* TOOLTIP */}
//       <div
//         className={`gt-tooltip ${placeAbove ? "gt-tooltip-above" : "gt-tooltip-below"}`}
//         style={{
//           top: tooltipTop,
//           left: tooltipLeft,
//           maxWidth: 320,
//           zIndex: 9999,
//         }}
//       >
//         <div className="gt-header">
//           <div className="gt-avatar">👤</div>
//           <div>
//             <div className="gt-guide-name">Guide from Audree</div>
//             <div className="gt-guide-subtitle">Quick tour</div>
//           </div>
//           <button className="gt-close" onClick={handleSkip}>×</button>
//         </div>

//         <div className="gt-content">
//           {step.title && <h3 className="gt-title">{step.title}</h3>}
//           {step.text && <p className="gt-text">{step.text}</p>}
//         </div>

//         <div className="gt-footer">
//           <span className="gt-progress">
//             {stepIndex + 1} of {steps.length}
//           </span>

//           <div className="gt-buttons">
//             <button
//               className="gt-prev-btn"
//               onClick={handlePrev}
//               disabled={stepIndex === 0}
//             >
//               ← Previous
//             </button>

//             {!allowInteraction && (
//               <button className="gt-next-btn" onClick={handleNext}>
//                 {isLast ? "Finish" : "Next →"}
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default GuidedTour;



// // src/components/GuidedTour/GuidedTour.jsx
// import React, { useEffect, useState } from "react";
// import "./GuidedTour.css";
// import { useNavigate } from "react-router-dom";

// const GuidedTour = ({
//   steps = [],
//   stepIndex,
//   setStepIndex,
//   onFinish,
//   allowNavigation = false,
// }) => {
//   const [targetElement, setTargetElement] = useState(null);
//   const navigate = useNavigate();

//   const step = Array.isArray(steps) && stepIndex != null ? steps[stepIndex] : null;
//   const isLast = stepIndex === steps.length - 1;
//   const allowInteraction = !!step?.allowInteraction;

//   // 1. Find target element with retry
//   useEffect(() => {
//     if (!step?.selector) return;
//     let attempts = 0;
//     let cancelled = false;

//     const findElement = () => {
//       if (cancelled) return;
//       const el = document.querySelector(step.selector);
//       if (el) {
//         setTargetElement(el);
//       } else if (attempts < 120) {
//         attempts++;
//         setTimeout(findElement, 250);
//       }
//     };

//     setTargetElement(null);
//     findElement();

//     return () => {
//       cancelled = true;
//     };
//   }, [step]);

//   // 2. Handle interaction → click or change
//   useEffect(() => {
//     if (!targetElement || !allowInteraction) return;

//     const advanceTour = () => {
//       setTimeout(() => {
//         setStepIndex((prev) => prev + 1);
//       }, 400);
//     };

//     if (targetElement.tagName === "INPUT" && targetElement.type === "checkbox") {
//       const handleChange = (e) => {
//         if (e.target.checked) advanceTour();
//       };
//       targetElement.addEventListener("change", handleChange);
//       return () => targetElement.removeEventListener("change", handleChange);
//     }

//     targetElement.addEventListener("click", advanceTour);
//     return () => targetElement.removeEventListener("click", advanceTour);
//   }, [targetElement, step, setStepIndex, allowInteraction]);

//   // 3. Scroll into view
//   useEffect(() => {
//     if (targetElement) {
//       targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
//     }
//   }, [targetElement]);

//   // 4. Disable body scroll
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, []);

//   if (!step || !targetElement) return null;

//   // ────────────────────────────────────────────────
//   // POSITIONING LOGIC - FIXED TO STAY INSIDE SCREEN
//   // ────────────────────────────────────────────────
//   const rect = targetElement.getBoundingClientRect();
//   const TOOLTIP_HEIGHT = 340;
//   const GAP = 24;
//   const MARGIN = 20; // minimum distance from screen edges

//   const spaceBelow = window.innerHeight - rect.bottom;
//   const spaceAbove = rect.top;

//   // Prefer BELOW, fallback to ABOVE
//   let placeAbove = spaceBelow < TOOLTIP_HEIGHT + GAP && spaceAbove > TOOLTIP_HEIGHT + GAP;

//   // Special case for top-of-screen elements (like header)
//   if (rect.top < 100) {
//     placeAbove = false; // force below for headers
//   }

//   const tooltipTop = placeAbove
//     ? Math.max(MARGIN, rect.top - TOOLTIP_HEIGHT - GAP)
//     : Math.min(rect.bottom + GAP, window.innerHeight - TOOLTIP_HEIGHT - MARGIN);

//   const tooltipWidth = 320;
//   const tooltipLeft = Math.max(
//     MARGIN,
//     Math.min(
//       rect.left + rect.width / 2 - tooltipWidth / 2,
//       window.innerWidth - tooltipWidth - MARGIN
//     )
//   );

//   // ────────────────────────────────────────────────
//   // Handlers
//   // ────────────────────────────────────────────────
//   const handleSkip = () => onFinish?.();

//   const handlePrev = () => {
//     if (stepIndex === 0) return;
//     const prevIndex = stepIndex - 1;
//     const prevStep = steps[prevIndex];
//     if (allowNavigation && prevStep?.route) {
//       navigate(prevStep.route, {
//         state: { resumeTour: true, stepIndex: prevIndex },
//       });
//     } else {
//       setStepIndex(prevIndex);
//     }
//   };

//   const handleNext = () => {
//     if (isLast) {
//       onFinish?.();
//       return;
//     }
//     const nextIndex = stepIndex + 1;
//     const nextStep = steps[nextIndex];
//     if (nextStep?.route && allowNavigation) {
//       navigate(nextStep.route, {
//         state: { resumeTour: true, stepIndex: nextIndex },
//       });
//     } else {
//       setStepIndex(nextIndex);
//     }
//   };

//   // ────────────────────────────────────────────────
//   // Render
//   // ────────────────────────────────────────────────
//   return (
//     <>
//       {/* BACKDROP / SPOTLIGHT */}
//       {allowInteraction ? (
//         <div
//           className="gt-spotlight"
//           style={{
//             position: "fixed",
//             top: rect.top - 50,
//             left: rect.left - 50,
//             width: rect.width + 100,
//             height: rect.height + 100,
//             borderRadius: "16px",
//             boxShadow: "0 0 0 9999px rgba(0,0,0,0.75)",
//             pointerEvents: "none",
//             zIndex: 9997,
//           }}
//         />
//       ) : (
//         <div className="gt-overlay" onClick={handleSkip} style={{ zIndex: 9997 }} />
//       )}

//       {/* HIGHLIGHT BORDER */}
//       <div
//         className="gt-highlight"
//         style={{
//           top: rect.top - 10,
//           left: rect.left - 10,
//           width: rect.width + 20,
//           height: rect.height + 20,
//           zIndex: 9998,
//         }}
//       />

//       {/* TOOLTIP */}
//       <div
//         className={`gt-tooltip ${placeAbove ? "gt-tooltip-above" : "gt-tooltip-below"}`}
//         style={{
//           position: "fixed",
//           top: tooltipTop,
//           left: tooltipLeft,
//           maxWidth: 340,
//           zIndex: 9999,
//         }}
//       >
//         <div className="gt-header">
//           <div className="gt-avatar">👤</div>
//           <div>
//             <div className="gt-guide-name">Guide from Audree</div>
//             <div className="gt-guide-subtitle">Quick tour</div>
//           </div>
//           <button className="gt-close" onClick={handleSkip}>×</button>
//         </div>
//         <div className="gt-content">
//           {step.title && <h3 className="gt-title">{step.title}</h3>}
//           {step.text && <p className="gt-text">{step.text}</p>}
//         </div>
//         <div className="gt-footer">
//           <span className="gt-progress">
//             {stepIndex + 1} of {steps.length}
//           </span>
//           <div className="gt-buttons">
//             <button
//               className="gt-prev-btn"
//               onClick={handlePrev}
//               disabled={stepIndex === 0}
//             >
//               ← Previous
//             </button>
//             {!allowInteraction && (
//               <button className="gt-next-btn" onClick={handleNext}>
//                 {isLast ? "Finish" : "Next →"}
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default GuidedTour;




// src/components/GuidedTour/GuidedTour.jsx
import React, { useEffect, useState } from "react";
import "./GuidedTour.css";
import { useNavigate } from "react-router-dom";

const GuidedTour = ({
  steps = [],
  stepIndex,
  setStepIndex,
  onFinish,
  allowNavigation = false,
}) => {
  const [targetElement, setTargetElement] = useState(null);
  const navigate = useNavigate();

  const step = Array.isArray(steps) && stepIndex != null ? steps[stepIndex] : null;
  const isLast = stepIndex === steps.length - 1;
  const allowInteraction = !!step?.allowInteraction;

  // 1. Find target element with retry
  useEffect(() => {
    if (!step?.selector) return;
    let attempts = 0;
    let cancelled = false;

    const findElement = () => {
      if (cancelled) return;
      const el = document.querySelector(step.selector);
      if (el) {
        setTargetElement(el);
      } else if (attempts < 120) {
        attempts++;
        setTimeout(findElement, 250);
      }
    };

    setTargetElement(null);
    findElement();

    return () => {
      cancelled = true;
    };
  }, [step]);

  // 2. Handle interaction → click on target OR anywhere outside (backdrop/overlay)
  useEffect(() => {
    if (!targetElement || !allowInteraction) return;

    const advanceTour = () => {
      setTimeout(() => {
        setStepIndex((prev) => Math.min(prev + 1, steps.length - 1));
      }, 400);
    };

    // Click on the target element (button, etc.)
    targetElement.addEventListener("click", advanceTour);

    // Click anywhere else (backdrop, overlay, outside dialog) → also advance
    const handleDocumentClick = (e) => {
      // Ignore clicks inside tooltip or target element
      if (
        !e.target.closest(".gt-tooltip") &&
        !targetElement.contains(e.target)
      ) {
        advanceTour();
      }
    };

    // Use capture phase to catch clicks before they reach other handlers
    document.addEventListener("click", handleDocumentClick, true);

    return () => {
      targetElement.removeEventListener("click", advanceTour);
      document.removeEventListener("click", handleDocumentClick, true);
    };
  }, [targetElement, step, setStepIndex, allowInteraction, steps.length]);

  // 3. Scroll target into view
  useEffect(() => {
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [targetElement]);

  // 4. Disable body scroll during tour
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  if (!step || !targetElement) return null;

  // ────────────────────────────────────────────────
  // POSITIONING LOGIC
  // ────────────────────────────────────────────────
  const rect = targetElement.getBoundingClientRect();
  const TOOLTIP_HEIGHT = 340;
  const GAP = 24;
  const MARGIN = 20;

  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;

  let placeAbove = spaceBelow < TOOLTIP_HEIGHT + GAP && spaceAbove > TOOLTIP_HEIGHT + GAP;

  if (rect.top < 100) {
    placeAbove = false;
  }

  const tooltipTop = placeAbove
    ? Math.max(MARGIN, rect.top - TOOLTIP_HEIGHT - GAP)
    : Math.min(rect.bottom + GAP, window.innerHeight - TOOLTIP_HEIGHT - MARGIN);

  const tooltipWidth = 320;
  const tooltipLeft = Math.max(
    MARGIN,
    Math.min(
      rect.left + rect.width / 2 - tooltipWidth / 2,
      window.innerWidth - tooltipWidth - MARGIN
    )
  );

  // ────────────────────────────────────────────────
  // Handlers
  // ────────────────────────────────────────────────
  const handleSkip = () => onFinish?.();

  const handlePrev = () => {
    if (stepIndex === 0) return;
    const prevIndex = stepIndex - 1;
    const prevStep = steps[prevIndex];
    if (allowNavigation && prevStep?.route) {
      navigate(prevStep.route, {
        state: { resumeTour: true, stepIndex: prevIndex },
      });
    } else {
      setStepIndex(prevIndex);
    }
  };

  const handleNext = () => {
    if (isLast) {
      onFinish?.();
      return;
    }
    const nextIndex = stepIndex + 1;
    const nextStep = steps[nextIndex];
    if (nextStep?.route && allowNavigation) {
      navigate(nextStep.route, {
        state: { resumeTour: true, stepIndex: nextIndex },
      });
    } else {
      setStepIndex(nextIndex);
    }
  };

  // ────────────────────────────────────────────────
  // Render
  // ────────────────────────────────────────────────
  return (
    <>
      {/* BACKDROP / SPOTLIGHT */}
      {allowInteraction ? (
        <div
          className="gt-spotlight"
          style={{
            position: "fixed",
            top: rect.top - 50,
            left: rect.left - 50,
            width: rect.width + 100,
            height: rect.height + 100,
            borderRadius: "16px",
            boxShadow: "0 0 0 9999px rgba(0,0,0,0.75)",
            pointerEvents: "none",
            zIndex: 9997,
          }}
        />
      ) : (
        <div className="gt-overlay" onClick={handleSkip} style={{ zIndex: 9997 }} />
      )}

      {/* HIGHLIGHT BORDER */}
      <div
        className="gt-highlight"
        style={{
          top: rect.top - 10,
          left: rect.left - 10,
          width: rect.width + 20,
          height: rect.height + 20,
          zIndex: 9998,
        }}
      />

      {/* TOOLTIP */}
      <div
        className={`gt-tooltip ${placeAbove ? "gt-tooltip-above" : "gt-tooltip-below"}`}
        style={{
          position: "fixed",
          top: tooltipTop,
          left: tooltipLeft,
          maxWidth: 340,
          zIndex: 9999,
        }}
      >
        <div className="gt-header">
          <div className="gt-avatar">👤</div>
          <div>
            <div className="gt-guide-name">Guide from Audree</div>
            <div className="gt-guide-subtitle">Quick tour</div>
          </div>
          <button className="gt-close" onClick={handleSkip}>×</button>
        </div>
        <div className="gt-content">
          {step.title && <h3 className="gt-title">{step.title}</h3>}
          {step.text && <p className="gt-text">{step.text}</p>}
        </div>
        <div className="gt-footer">
          <span className="gt-progress">
            {stepIndex + 1} of {steps.length}
          </span>
          <div className="gt-buttons">
            <button
              className="gt-prev-btn"
              onClick={handlePrev}
              disabled={stepIndex === 0}
            >
              ← Previous
            </button>
            {/* Show "Next →" ONLY for NON-interactive (non-button) steps */}
            {!allowInteraction && !isLast && (
              <button className="gt-next-btn" onClick={handleNext}>
                Next →
              </button>
            )}

            {/* End Tour on last step */}
            {isLast && (
              <button className="gt-finish-btn" onClick={() => {
                onFinish?.();
                navigate("/users/dashboard");
              }}>
                End Tour
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GuidedTour;